import { render, staticRenderFns } from "./EditNoteDialog.vue?vue&type=template&id=6cc9ff60&"
import script from "./EditNoteDialog.vue?vue&type=script&lang=ts&"
export * from "./EditNoteDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports